<div class="page-header" [class.page-header--compact]="variant === 'compact-inline'" *ngIf="title || description">
  <div class="page-header--content">
    <div class="page-header--text">
      <h1 class="page-header--title" *ngIf="title">{{ title }}</h1>
      <p class="page-header--description" *ngIf="description">{{ description }}</p>
    </div>
    <div class="page-header--actions">
      <ng-content select="[pageHeaderActions]"></ng-content>
    </div>
  </div>
  <hr class="page-header--divider">
</div>

